/**
 * 화면의 색 — 등급 색과 솥 물약 색(작업지시서 6절 「솥 안 물약이 넣는 재료 색으로 섞이며 바뀌고」).
 *
 * 아이템마다 색을 묶음 파일에 적지 않는다 — 원소 넷만 정하고, 나머지는 갈래 색에서 이름표로 조금씩 비튼다.
 * 그래서 아이템이 늘어도 여기를 고칠 일이 없다.
 */
import type { Item } from './api';

/** 테두리 · 빛용 */
export const GRADE_COLORS = ['#d1d5db', '#22c55e', '#3b82f6', '#a855f7', '#f59e0b'];
/** 글자용 — 위 색은 흰 바탕 글자로는 흐리다(일반의 연회색은 거의 안 보였다 · 스위티 2026-11-04) */
export const GRADE_TEXT = ['#4b5563', '#15803d', '#1d4ed8', '#7e22ce', '#b45309'];

const ELEMENT: Record<string, [number, number, number]> = {
    water: [59, 130, 246],
    fire: [239, 68, 68],
    earth: [146, 98, 52],
    wind: [165, 243, 252],
};

const GROUP: Record<string, [number, number, number]> = {
    nature: [34, 197, 94],
    mineral: [148, 163, 184],
    creature: [249, 115, 22],
    object: [234, 179, 8],
    treasure: [245, 158, 11],
    story: [197, 58, 107],
};

const EMPTY: [number, number, number] = [236, 72, 153];

function hash(text: string): number {
    let h = 0;
    for (let i = 0; i < text.length; i++) h = (h * 31 + text.charCodeAt(i)) | 0;
    return Math.abs(h);
}

/** 아이템 하나의 물약 색 */
export function itemRgb(item: Pick<Item, 'key' | 'group'>): [number, number, number] {
    if (ELEMENT[item.key]) return ELEMENT[item.key];
    const base = GROUP[item.group] ?? EMPTY;
    const shift = (hash(item.key) % 41) - 20; // 같은 갈래라도 아이템마다 조금씩 다르게
    return base.map((c) => Math.max(0, Math.min(255, c + shift))) as [number, number, number];
}

/** 솥에 든 재료를 섞은 색 — 비었으면 기본 분홍 */
export function potionColor(items: Pick<Item, 'key' | 'group'>[]): string {
    if (items.length === 0) return `rgb(${EMPTY.join(',')})`;
    const sum = items.map(itemRgb).reduce((a, c) => [a[0] + c[0], a[1] + c[1], a[2] + c[2]], [0, 0, 0]);
    return `rgb(${sum.map((c) => Math.round(c / items.length)).join(',')})`;
}
